import { z } from 'zod';

// Valid Facebook match keys.
// https://developers.facebook.com/docs/marketing-api/offline-conversions/
export enum MatchKeys {
  email = 'email',
  phone = 'phone',
  gen = 'gen',
  doby = 'doby',
  dobm = 'dobm',
  dobd = 'dobd',
  ln = 'ln',
  fn = 'fn',
  fi = 'fi',
  ct = 'ct',
  st = 'st',
  zip = 'zip',
  country = 'country',
  extern_id = 'extern_id',
  lead_id = 'lead_id',
}

export const matchKeysSchema = z.nativeEnum(MatchKeys);

export const matchKeyTSchema = z.object({
  email: z.string().or(z.string().nullable().array()).nullish(),
  phone: z.string().or(z.string().nullable().array()).nullish(),
  gen: z.string().nullish(),
  doby: z.string().nullish(),
  dobm: z.string().nullish(),
  dobd: z.string().nullish(),
  ln: z.string().nullish(),
  fn: z.string().nullish(),
  fi: z.string().nullish(),
  ct: z.string().nullish(),
  st: z.string().nullish(),
  zip: z.string().nullish(),
  country: z.string().nullish(),
  extern_id: z.string().nullish(),
  lead_id: z.string().nullish(),
});

export type MatchKeyT = z.infer<typeof matchKeyTSchema>;

export const isMatchKey = <T = MatchKeys>(mk: any): mk is T => mk in MatchKeys;

export const sensitiveKeys = Object.keys(MatchKeys).filter((k) => {
  return k !== MatchKeys.extern_id && k !== MatchKeys.lead_id;
});
